<template>
	<article class="list-card h-full bg-bg-001 p-3">
		<div class="flex flex-col sm:flex-row md:flex-col lg:flex-row justify-start items-start">
			<a 
				v-if="showImage && isImgValid" 
				:href="href + urlParams"
				@click="getArticle"
			>
				<div
					class="mb-2 sm:mb-0 sm:mr-2 md:mb-2 md:mr-0 lg:mb-0 lg:mr-2"
					:style="{
						'width': imgWidth
					}"
				>
					<img 
						:src="imgUrl" 
						:style="{
							width: '100%'
						}"
						:alt="headline || ''"
						@error="onImageError"
					>
				</div>
			</a>
			<div class="flex-1">
				<div v-if="hasMeta" class="flex flex-row justify-start items-center text-sm mb-2">
					<span v-if="category" class="text-red mb-0">{{ category}}</span>
					<span v-if="subcategory" class="text-red mb-0 mx-1">/ {{ subcategory}}</span>
					<span v-if="isCme" class="text-tiny leading-none bg-red text-text-002 py-1 px-2 mb-0">CME</span>
				</div>
				<!-- eslint-disable vue/no-v-html -->
				<a 
					v-if="headline && showHeadline" 
					:href="href + urlParams"
					@click="getArticle"
				>
					<h3 v-html="headline"></h3>
				</a>
				<a 
					v-if="subhead && showSubhead" 
					:href="href + urlParams"
					@click="getArticle"
				>
					<h5 v-html="subhead"></h5>
				</a>
				<h6 v-if="date && showDate" v-html="date"></h6>
				<h6 v-if="author && showAuthor" v-html="author"></h6>
				<a 
					v-if="body && showBody" 
					:href="href + urlParams"
					@click="getArticle"
				>
					<p class="text-sm" v-html="body"></p>
				</a>
				<!-- eslint-enable vue/no-v-html -->
			</div>
		</div>
	</article>
</template>

<script>
export default {
	name: 'ListCard',
	props: {
		imgUrl: {
			type: String,
			default: null
		},
		imgWidth: {
			type: String,
			default: '96px'
		},
		category: {
			type: String,
			default: null
		},
		subcategory: {
			type: String,
			default: null
		},
		isCme: {
			type: Boolean,
			default: false
		},
		headline: {
			type: String,
			default: null
		},
		subhead: {
			type: String,
			default: null
		},
		date: {
			type: String,
			default: null
		},
		author: {
			type: String,
			default: null
		},
		body: {
			type: String,
			default: null
		},
		href: {
			type: String,
			default: '/'
		},
		fields: {
			type: [String, Array],
			default: 'all'
		}
	},
	data() {
		return {
			isImgValid: !!this.imgUrl
		}
	},
	computed: {
		showImage() {
			return this.fields === 'all' || this.fields.includes('image')
		},
		showTags() {
			return this.fields === 'all' || this.fields.includes('tags')
		},
		showCme() {
			return this.fields === 'all' || this.fields.includes('cme')
		},
		showHeadline() {
			return this.fields === 'all' || this.fields.includes('headline')
		},
		showSubhead() {
			return this.fields === 'all' || this.fields.includes('subhead')
		},
		showDate() {
			return this.fields === 'all' || this.fields.includes('date')
		},
		showAuthor() {
			return this.fields === 'all' || this.fields.includes('author')
		},
		showBody() {
			return this.fields === 'all' || this.fields.includes('body')
		},
		hasMeta() {
			return (this.category && this.showTags) || (this.subcategory && this.showTags) || (this.isCme && this.showCme)
		},
		urlParams() {
			return this?.$route?.query 
				? '?' + Object.keys(this.$route.query)
					.map((param) => {
						return param + '=' + this.$route.query[param]
					})
					.join('&')
				: ''
		}
	},
	methods: {
		getArticle() {
			this.$store.dispatch('getArticlePage', this.id)
		},
		onImageError() {
			this.isImgValid = false
		}
	}
}
</script>